// extracted by mini-css-extract-plugin
module.exports = {"legalPageNav":"LegalNav_legalPageNav__36MrM","col":"LegalNav_col__FjDmM"};